import React, { PureComponent } from "react";
// import { Link } from "react-router-dom";
import axios from "axios";
import Cookies from "universal-cookie";
import Button from "@material-ui/core/Button/Button";
import Snackbar from "@material-ui/core/Snackbar";

// import Header from "../../components/header/Header";
import CityDetail from "../../components/city-detail/CityDetail";
import CityCreation from "../../components/city-creation/CityCreation";
import Footer from "../../components/footer/Footer";
import Messages from "../../components/messages/Messages";

import "./Instructor.scss";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import { withRouter } from "react-router-dom";

import ReactCSSTransitionGroup from "react-addons-css-transition-group";

class Instructor extends PureComponent {
  constructor() {
    super();

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.cookies = new Cookies();
    this.token = this.cookies.get("token");
    this.delay = (ms) => new Promise((res) => setTimeout(res, ms));

    // this.eventSource = new EventSource(FETCH_URL + "/events/");

    this.state = {
      cityList: [],
      adVancedCitiesList: [],
      account_id: "",
      snackMsg: "Welcome!",
      snackOpen: false,
      snackType: "snack",
      snackAutoHideDuration: null,
      showCompleted: true,
      // eventSourceMessage: "",
      navLinks: [
        // {
        //   name: "Frank Batten School",
        //   href: "https://batten.virginia.edu",
        //   icon: "iconBatten",
        //   text: "textBatten",
        //   target: "_blank"
        // },
        // {
        //   name: "CLSG",
        //   href: "https://www.clsgbatten.org",
        //   icon: "iconClsg",
        //   text: "textClsg",
        //   target: "_blank"
        // },
        {
          href: "https://dms.academy/",
          icon: "iconDMS",
          target: "_blank",
        },
      ],
      configurations: [
        {
          name: 1,
          description:
            "Configuration 1 -- 10 rounds with 5 forecasts per round.",
        },
        // {
        //   name: 2,
        //   description:
        //   "Game 1 Configuration -- 6 rounds with 5 forecasts per round."
        // },
        // {
        //   name: 3,
        //   description:
        //   "Game 2 Configuration -- 15 rounds with 3 forecasts per round."
        // },
        // {
        //   name: 4,
        //   description:
        //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi in velit quam. Etiam volutpat, massa a aliquam efficitur, enim orci auctor odio, in ornare nunc lorem vel arcu."
        // }
      ],
      colors: [
        {
          name: "dark grey",
          color: "#707070",
        },
        {
          name: "bright orange",
          color: "#FF6302",
        },
        {
          name: "metro red",
          color: "#DF344A",
        },
        {
          name: "metro blue",
          color: "#5399C9",
        },
        {
          name: "metro purple",
          color: "#B75895",
        },
        {
          name: "metro green",
          color: "#34A351",
        },
        {
          name: "metro yellow",
          color: "#FDCB2E",
        },
        {
          name: "light green",
          color: "#D8E9D8",
        },
        {
          name: "light blue",
          color: "#D5E5F3",
        },
      ],
      inDashboard: null,
      advanceGameMessage: [],
      navWidth: -400,
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    };
  }

  messageTemporary = async (time) => {
    // await this.delay(time);
    this.setState({
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    });
    // await this.delay(time + 1000);
    // this.setState({
    //   messageMessage: null,
    //   messageType: null,
    //   messageFunction: null
    // })
  };

  fetchCityList = () => {
    axios
      .get(this.fetchURL + "/api/v1/city_list/", {
        headers: {
          Authorization: `Token ${this.token}`,
        },
      })
      .then((response) => {
        console.group("Instructor:fetchCityList");
        console.log(response.data);
        console.groupEnd();
        if (response.data.success) {
          let cityList = response.data.data;
          this.setState({ cityList: cityList });
        }
      })
      .catch((error) => {
        console.log(error.response);
      });
  };

  // fetchUserNameAndPhoto = () => {
  //   axios
  //     .all([
  //       axios.get(this.camsURL + "/api/v1/users/", {
  //         headers: { Authorization: `Token ${this.token}` }
  //       }),
  //       axios.get(this.camsURL + "/api/v1/users/photo/", {
  //         headers: { Authorization: `Token ${this.token}` }
  //       })
  //     ])
  //     .then(
  //       axios.spread((detailsResponse, photoResponse) => {
  //         console.group("Instructor:fetchUserNameAndPhoto");
  //         console.log(detailsResponse);
  //         console.log(photoResponse);
  //         console.groupEnd();

  //         if (detailsResponse.status === 200 && photoResponse.status === 200) {
  //           let rolesInfo = detailsResponse.data;
  //           let photoInfo = photoResponse.data;
  //           this.setState(() => {
  //             return {
  //               navLinks: this.state.navLinks.map(item => {
  //                 if (item.name === "Instructor") {
  //                   item.name =
  //                     rolesInfo.first_name + " " + rolesInfo.last_name;
  //                   item.bg = photoInfo.host + photoInfo.profile_image;
  //                   return item;
  //                 } else {
  //                   return item;
  //                 }
  //               })
  //             };
  //           });
  //         }
  //       })
  //     )
  //     .catch(error => {
  //       console.log(error.response);
  //     });
  // };

  authUser = () => {
    axios
      .get(this.camsURL + "/api/auth/user", {
        headers: {
          Authorization: `Token ${this.token}`,
        },
      })
      .then((response) => {
        // console.group("Instructor:authUser");
        // console.log(response);
        if (response.data.id) {
          this.setState({
            account_id: response.data.id,
          });
          this.fetchCityList(response.data.id);
        } else {
          window.location.replace("/");
        }
        // console.groupEnd();
      })
      .catch((error) => {
        console.log(error.response);
        window.location.replace("/");
      });
  };

  componentDidMount = () => {
    this.authUser();
    this.setState({
      inDashboard: false,
    });
  };

  createCity = (data) => {
    console.log(data);
    console.log("Config Number" + data.configNumber);
    return axios
      .post(
        this.fetchURL + "/api/v1/cities/",
        {
          city_name: data.cityName,
          purpose: data.purpose,
          site_name: data.siteName,
          config: data.configNumber,
          account_id: this.state.account_id,
          city_color: data.cityColor,
        },
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        if (response.data.success) {
          console.group("Instrucor:createCity");
          console.log("City Added!");
          console.log(response.data);
          console.groupEnd();

          this.setState((prevState) => ({
            cityList: prevState.cityList.concat(response.data.data),
          }));

          this.setState({
            // snackOpen: true,
            // snackMsg: response.data.message,
            // snackType: "snack-success",
            // snackAutoHideDuration: 5000,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Success",
          });

          return true;
        } else {
          console.log(response.data.message);
          this.setState({
            // snackOpen: true,
            // snackMsg: response.data.message,
            // snackType: "snack-error",
            // snackAutoHideDuration: 5000,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Error",
          });

          return false;
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          // snackOpen: true,
          // snackMsg: "Something went wrong. Please try again later.",
          // snackType: "snack-error",
          // snackAutoHideDuration: 5000,
          messageDivVisibility: "visible",
          messageMessage: "Something went wrong. Please try again later.",
          messageType: "Error",
        });

        return false;
      });
  };

  onNavLinkClick = (e, nav) => {
    e.preventDefault();

    if (nav.target === "_") {
      //   Nothing
    } else if (nav.target === "_blank") {
      window.open(nav.href, "_blank");
    } else if (nav.target === "_self") {
      this.props.history.push("/info");
    } else {
      this.setState({
        snackType: "snack",
        snackOpen: true,
        snackMsg: "Are you sure you want to logout?",
      });
    }
  };

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  logoutPrevent = (e) => {
    e.preventDefault();
    this.setState({
      // snackType: "snack-logout",
      // snackOpen: true,
      // snackMsg: "Are you sure you want to leave?",
      messageDivVisibility: "visible",
      messageMessage: "Are you sure you want to leave?",
      messageType: "Warning",
      messageFunction: "Logout",
    });
  };

  logoutYes = (e) => {
    e.preventDefault();
    this.setState({ requestSent: true });

    axios
      .post(
        this.camsURL + "/api/auth/logout",
        {},
        {
          headers: { Authorization: `Token ${this.token}` },
        }
      )
      .then((response) => {
        this.setState({ requestSent: false });

        if (response.status === 204 || response.status === 200) {
          this.setState({
            snackOpen: true,
            snackMsg: `Logout successful!`,
            snackType: "snack-success",
            snackAutoHideDuration: 5000,
          });
          this.cookies.remove("token");
          window.location.replace("/");
        } else {
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
            snackAutoHideDuration: 5000,
          });
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ requestSent: false });
      });
  };

  updateStatus = (e, cityId) => {
    e.preventDefault();
    const cityInfo = this.state.cityList.find(
      (city) => city.city_id === cityId
    );

    cityInfo &&
      axios
        .put(
          this.fetchURL + "/api/v1/cities/",
          {
            city_id: cityInfo.city_id,
            is_active: !cityInfo.city_is_active,
          },
          { headers: { Authorization: `Token ${this.token}` } }
        )
        .then((response) => {
          if (response.data.success) {
            console.group("Instructor:updateStatus");
            console.log("Game status Updated!");
            console.groupEnd();
            this.setState((prevState) => ({
              cityList: prevState.cityList.map((city) => {
                if (city.city_id === cityInfo.city_id) {
                  return Object.assign({}, city, {
                    city_is_active: !city.city_is_active,
                  });
                } else {
                  return city;
                }
              }),
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: "snack-success",
              snackAutoHideDuration: 5000,
            }));
          } else {
            console.log(response.data.message);
            this.setState({
              snackOpen: true,
              snackMsg: response.data.message,
              snackType: "snack-error",
              snackAutoHideDuration: 5000,
            });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            snackOpen: true,
            snackMsg: "Something went wrong. Please try again later.",
            snackType: "snack-error",
            snackAutoHideDuration: 5000,
          });
        });
  };

  preventAdvance = (e) => {
    e.preventDefault();

    let id = e.target.getAttribute("id");
    let name = e.target.getAttribute("name");
    let skey = e.target.getAttribute("skey");

    this.setState({
      // snackType: "snack-advance",
      // snackOpen: true,
      // snackMsg: "Are you sure you want to advance the game?",
      messageDivVisibility: "visible",
      messageMessage:
        'Please double check the "current year". Are you sure you want to advance the game?',
      messageType: "Warning",
      messageFunction: "Advance",
      advanceId: id,
      advanceName: name,
      advanceSkey: skey,
    });
  };

  advanceGame = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
    let id = e.target.getAttribute("id");
    let name = e.target.getAttribute("name");
    let skey = e.target.getAttribute("skey");
    console.log(id);
    this.setState({
      advanceGameMessage: this.state.advanceGameMessage.concat(parseInt(id)),
    });
    axios
      .post(
        this.fetchURL + "/api/v1/cities/advance/",
        {
          city_id: id,
          city_name: name,
          city_skey: skey,
        },
        {
          headers: {
            Authorization: `Token ${this.token}`,
          },
        }
      )
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.group("Policy Advance Test Test");
          console.log("Test Successfull!");
          console.log(response);
          console.log(response.data.data);
          console.log(response.data.data.id);
          console.groupEnd();

          let advancedGameMessageArr = [...this.state.advanceGameMessage];
          var index = advancedGameMessageArr.indexOf(
            parseInt(response.data.data.id)
          );
          if (index !== -1) {
            advancedGameMessageArr.splice(index, 1);
          }

          this.fetchCityList();
          this.setState({
            // snackOpen: true,
            // snackMsg: response.data.message,
            // snackType: "snack-success",
            // snackAutoHideDuration: 5000,
            advanceGameMessage: advancedGameMessageArr,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Success",
          });
        } else {
          let advancedGameMessageArr = [...this.state.advanceGameMessage];
          var indexForError = advancedGameMessageArr.indexOf(parseInt(id));
          if (indexForError !== -1) {
            advancedGameMessageArr.splice(indexForError, 1);
          }
          console.log(response.data.message);
          this.setState({
            // snackOpen: true,
            // snackMsg: response.data.message,
            // snackType: "snack-error",
            // snackAutoHideDuration: 5000,
            advanceGameMessage: advancedGameMessageArr,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Error",
          });
        }
      })
      .catch((error) => {
        let advancedGameMessageArr = [...this.state.advanceGameMessage];
        var indexForError = advancedGameMessageArr.indexOf(parseInt(id));
        if (indexForError !== -1) {
          advancedGameMessageArr.splice(indexForError, 1);
        }
        console.log(error);
        this.setState({ startRequestSent: false });
        this.setState({
          // snackOpen: true,
          // snackMsg: "Something went wrong. Please try again later.",
          // snackType: "snack-error",
          // snackAutoHideDuration: 5000,
          advanceGameMessage: advancedGameMessageArr,
          messageDivVisibility: "visible",
          messageMessage:
            "Slow Network, please check game year and try to advance again if necessary.",
          messageType: "Error",
        });
      });
    console.groupEnd();
  };

  openNav = (e) => {
    e.preventDefault();
    console.log("opened");
    this.setState({
      navWidth: 0,
    });
  };

  closeNav = (e) => {
    console.log("closed");
    e.preventDefault();
    this.setState({
      navWidth: -400,
    });
  };

  closeMessage = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
  };

  render() {
    return (
      <div>
        {/* <div className="persistantBrand flex flex-50-50">
          {this.state.navLinks.map((item, index) => (
            <a key={index} href={item.href} target={item.target}>
            <span className={item.icon}></span>
            <span className={item.text}>{item.name}</span>
          </a>
        ))}
        </div> */}

        <Messages
          messageDivVisibility={this.state.messageDivVisibility}
          messageMessage={this.state.messageMessage}
          messageType={this.state.messageType}
          messageFunction={this.state.messageFunction}
          closeMessage={this.closeMessage}
          logoutYes={this.logoutYes}
          onDistrictSubmitHandler={this.onDistrictSubmitHandler}
          onCitySubmitHandler={this.onCitySubmitHandler}
          onEngagementSubmitHandler={this.onEngagementSubmitHandler}
          advanceId={this.state.advanceId}
          advanceName={this.state.advanceName}
          advanceSkey={this.state.advanceSkey}
          advanceGame={this.advanceGame}
        />
        <div
          id="mySidenav"
          class="sidenav"
          style={{ right: `${this.state.navWidth}px` }}
        >
          <a
            href="javascript:void(0)"
            className="closebtn"
            onClick={(e) => this.closeNav(e)}
          >
            &times;
          </a>
          <div className="logoutDiv">
            <button className="logout" onClick={(e) => this.logoutPrevent(e)}>
              Logout
            </button>
          </div>
          <p>Resources</p>
          <hr />
          <a
            href="https://res.cloudinary.com/uvasims/raw/upload/v1581527162/policy_dictionary.pdf"
            target="_blank"
          >
            Policy Dictionary
          </a>
          {/* <a href="#">References</a> */}
          <p>Links</p>
          <hr />
          {this.state.navLinks.map((item, index) => (
            <a key={index} href={item.href} target={item.target}>
              {item.name} <span className={item.icon} />
            </a>
          ))}
        </div>

        {/* <Header/> */}
        <div className="instructorNav flex flex-auto">
          <div className="sudoLogo" />
          <div className="metroLogo" />
          {/* <h3 className="instructorRole">Instructor</h3> */}
          {/* {window.location.href.split("/")[5] ? (
            <h1 className="instructorLogo">
              METRO -{" "}
              {window.location.href
                .split("/")[5]
                .replace("_", " ")
                .toUpperCase()}
            </h1>
          ) : (
            <h1 className="instructorLogo">METRO</h1>
          )} */}
          <span
            className="navSpan"
            style={{ marginRight: "4%" }}
            onClick={(e) => this.openNav(e)}
          >
            &#9776; Nav
          </span>
        </div>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.snackOpen}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          className={this.state.snackType}
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === "snack"
              ? [
                  <Button key="yes" color="secondary" onClick={this.logoutYes}>
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>,
                ]
              : this.state.snackType === "snack-logout"
                ? [
                    <Button key="yes" color="inherit" onClick={this.logoutYes}>
                      Yes
                    </Button>,
                    <Button key="no" color="inherit" onClick={this.handleClose}>
                      No
                    </Button>,
                  ]
                : this.state.snackType === "snack-advance"
                  ? [
                      <Button
                        key="yes"
                        color="inherit"
                        onClick={this.advanceGame}
                      >
                        Yes
                      </Button>,
                      <Button
                        key="no"
                        color="inherit"
                        onClick={this.handleClose}
                      >
                        No
                      </Button>,
                    ]
                  : []
          }
        />
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          <div className="backgroundSignUp" />
        </ReactCSSTransitionGroup>
        <div className="cityCreateWrapper">
          <hr />{" "}
          <ReactCSSTransitionGroup
            transitionName="fade"
            transitionAppear={true}
            transitionAppearTimeout={500}
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            <CityCreation
              createCity={this.createCity}
              config={this.state.configurations}
              colors={this.state.colors}
            />
          </ReactCSSTransitionGroup>
          <hr />
        </div>
        <div className="cityCreateWrapper">
          <div className={`metrics__wrapper`}>
            <div className="flex flex-justify-between">
              <h3 className="creationHeader">Your Cities</h3>

              {this.state.cityList.length > 0 && (
                <button
                  className="button completed"
                  onClick={() =>
                    this.setState((prevState) => {
                      return { showCompleted: !prevState.showCompleted };
                    })
                  }
                >
                  {this.state.showCompleted
                    ? "Hide Completed"
                    : "Show Completed"}
                </button>
              )}
            </div>

            {this.state.cityList.map((item) => {
              return (
                <ReactCSSTransitionGroup
                  transitionName="fade"
                  transitionAppear={true}
                  transitionAppearTimeout={500}
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={300}
                >
                  <CityDetail
                    key={item.city_id}
                    display={this.state.showCompleted}
                    updateStatus={this.updateStatus}
                    id={item.city_id}
                    name={item.city_name}
                    code={item.game_code}
                    skey={item.city_skey}
                    currYear={item.current_year}
                    purpose={item.purpose}
                    is_active={item.city_is_active}
                    is_complete={item.city_is_complete}
                    preventAdvance={this.preventAdvance}
                    advanceGame={this.advanceGame}
                    inDashboard={this.state.inDashboard}
                    advanceGameMessage={this.state.advanceGameMessage}
                    color={item.color}
                  />
                </ReactCSSTransitionGroup>
              );
            })}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Instructor);
